'use client'

import { resetAllApiState } from '@/stores/store'
import { useSession } from '@/utils/auth/auth-client'
import { useAppDispatch } from '@/utils/redux-hooks'

import { useEffect, useRef } from 'react'

/**
 * Drops every cached API response when the signed-in user changes under this
 * tab without a page load: an impersonation started or ended in another tab
 * swaps the shared cookie, and the next session refetch here comes back as
 * someone else. RTK's cache keys carry no user, so every consumer would keep
 * rendering the previous identity's data until it happened to refetch.
 */
export function useResetCacheOnIdentityChange() {
  const { data: session } = useSession()
  const dispatch = useAppDispatch()
  const userId = session?.user?.id
  const previous = useRef(userId)

  useEffect(() => {
    // A signed-out gap keeps the last user, so signing back in as someone else
    // in the same tab resets too.
    if (previous.current && userId && previous.current !== userId) {
      resetAllApiState(dispatch)
    }
    if (userId) previous.current = userId
  }, [userId, dispatch])
}
